export const UserManager = () => {
    return (
    <view>
        {'Quản lý khách hàng'}
    </view>);
}